export const safeJsonParse = (
  s: string
): Record<any, any> | Array<any> | null => {
  try {
    return JSON.parse(s);
  } catch (error) {
    return null;
  }
};
